import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../providers/root-store-provider';
import { Dropdown } from '../../dropdown/dropdown';
import { DropdownMenu } from '../../dropdown/menu/dropdown-menu';
import { IconArrowDown } from '../../icons/arrow-down';
import { cn } from '../../../../utils/tailwind';

export const AssetChangeCurrency: React.FC = observer(() => {
    const { currencyStore, portfolioStore, authStore } = useRootStore();
    const user = authStore.userProfile;

    const portfolioCurrency = portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode;

    React.useEffect(() => {
        if (currencyStore.currencies.length === 0) {
            currencyStore.fetchCurrencyList();
        }
    }, [currencyStore]);

    const onChangeCurrency = (currencyCode: string) => {
        portfolioStore.changeCurrency(currencyCode);
    };

    // Read-only portfolios do not have their own mutable trades/currency settings.
    if (portfolioStore.selectedPortfolio.readOnly || !user) {
        return null;
    }

    return (
        <Dropdown
            content={
                <DropdownMenu maxHeight={20}>
                    {currencyStore.currencies.map((currency) => (
                        <li
                            key={currency.code}
                            onClick={() => onChangeCurrency(currency.code)}
                            className={cn(
                                'flex cursor-pointer items-center border-t border-solid border-divider px-[1.8rem] py-[1.2rem] font-medium text-text transition-colors first:border-t-0 hover:text-text-muted',
                                currency.code === portfolioCurrency &&
                                    'rounded-[10rem] border-t-transparent bg-neutral-gray/40 font-bold [&+li]:border-t-transparent',
                            )}
                        >
                            {currency.code}
                        </li>
                    ))}
                </DropdownMenu>
            }
            position="bottom"
            size="small"
        >
            <IconArrowDown />
        </Dropdown>
    );
});
